// 메뉴 권한 관리 유틸리티

// 사용자 등급 정의
export const USER_GRADES = {
  GUEST: 'guest',
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  PLATINUM: 'platinum',
  DIAMOND: 'diamond'
};

// 기본 메뉴 권한 설정 (app-config.json이 로드되지 않을 때 사용)
export const DEFAULT_MENU_PERMISSIONS = {
  [USER_GRADES.GUEST]: ['board', 'travel'], // 게스트도 여행 플래너 접근 가능
  [USER_GRADES.BRONZE]: ['board', 'travel'],
  [USER_GRADES.SILVER]: ['board', 'travel'],
  [USER_GRADES.GOLD]: ['board', 'travel'],
  [USER_GRADES.PLATINUM]: ['board', 'travel'],
  [USER_GRADES.DIAMOND]: ['board', 'travel']
};

// 사용자 등급을 문자열로 변환
export const getUserGradeString = (userGrade) => {
  if (!userGrade) return USER_GRADES.GUEST;

  const grade = userGrade.toString().toLowerCase();
  switch (grade) {
    case '0':
    case 'guest':
      return USER_GRADES.GUEST;
    case '1':
    case 'bronze':
      return USER_GRADES.BRONZE;
    case '2':
    case 'silver':
      return USER_GRADES.SILVER;
    case '3':
    case 'gold':
      return USER_GRADES.GOLD;
    case '4':
    case 'platinum':
      return USER_GRADES.PLATINUM;
    case '5':
    case 'diamond':
      return USER_GRADES.DIAMOND;
    default:
      return USER_GRADES.GUEST;
  }
};

// app-config.json에서 메뉴 설정 불러오기 (config를 파라미터로 받음)
export const getMenuSettings = (config = null) => {
  try {
    if (config && config.menuPermissions) {
      console.log('🔧 [menuPermissions] app-config.json에서 메뉴 설정 사용:', config.menuPermissions);
      return config.menuPermissions;
    }

    console.log('🔧 [menuPermissions] 기본 메뉴 설정 사용');
    return DEFAULT_MENU_PERMISSIONS;
  } catch (error) {
    console.error('❌ [menuPermissions] 메뉴 설정 로드 실패:', error);
    return DEFAULT_MENU_PERMISSIONS;
  }
};

// 사용자가 특정 메뉴에 접근할 수 있는지 확인
export const hasMenuPermission = (userGrade, menuId, config = null, user = null) => {
  // 관리자는 모든 메뉴에 접근 가능
  if (user && isAdminUser(user)) {
    console.log(`🔍 [menuPermissions] 관리자 권한 확인: admin -> ${menuId} = true`);
    return true;
  }

  const gradeString = getUserGradeString(userGrade);
  const menuSettings = getMenuSettings(config);
  const allowedMenus = menuSettings[gradeString] || DEFAULT_MENU_PERMISSIONS[gradeString] || [];

  const hasPermission = allowedMenus.includes(menuId);
  console.log(`🔍 [menuPermissions] 권한 확인: ${gradeString} -> ${menuId} = ${hasPermission}`);

  return hasPermission;
};

// 사용자가 접근 가능한 메뉴 목록 반환
export const getAvailableMenus = (userGrade, config = null) => {
  const gradeString = getUserGradeString(userGrade);
  const menuSettings = getMenuSettings(config);
  const availableMenus = menuSettings[gradeString] || DEFAULT_MENU_PERMISSIONS[gradeString] || [];

  console.log(`📋 [menuPermissions] 사용 가능한 메뉴: ${gradeString} -> [${availableMenus.join(', ')}]`);

  return availableMenus;
};

// 관리자 권한 확인 (기존 로직 유지)
export const isAdminUser = (user) => {
  return user?.role === 'admin' || user?.role === 'moderator';
};

// 프로덕션 환경에서 관리자 메뉴 표시 여부
export const shouldShowAdminMenu = (user) => {
  return isAdminUser(user) && process.env.NODE_ENV !== 'production';
};